import React, { useEffect, useState } from 'react';
import { CheckCircle, XCircle, X } from 'lucide-react';

const notificationTypes = {
  success: {
    icon: CheckCircle,
    bgColor: 'bg-green-500/20',
    borderColor: 'border-green-500/30',
    textColor: 'text-green-400',
    iconColor: 'text-green-400'
  },
  error: {
    icon: XCircle,
    bgColor: 'bg-red-500/20',
    borderColor: 'border-red-500/30',
    textColor: 'text-red-400',
    iconColor: 'text-red-400'
  },
  info: {
    icon: CheckCircle,
    bgColor: 'bg-blue-500/20',
    borderColor: 'border-blue-500/30',
    textColor: 'text-blue-400',
    iconColor: 'text-blue-400'
  }
};

export default function Notification({ 
  message, 
  type = 'info', 
  isVisible, 
  onClose, 
  duration = 3000 
}) {
  const [isShowing, setIsShowing] = useState(isVisible);
  const config = notificationTypes[type];
  const Icon = config.icon;

  useEffect(() => {
    setIsShowing(isVisible);
    
    if (isVisible && duration > 0) {
      const timer = setTimeout(() => {
        setIsShowing(false);
        if (onClose) onClose();
      }, duration);
      
      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);

  const handleClose = () => {
    setIsShowing(false);
    if (onClose) onClose();
  };

  if (!isShowing) return null;

  return (
    <div className="fixed top-4 right-4 z-50 animate-in slide-in-from-right-2 duration-300">
      <div className={`flex items-center gap-3 px-4 py-3 rounded-lg border ${config.bgColor} ${config.borderColor} shadow-lg backdrop-blur-sm`}>
        <Icon className={`w-5 h-5 ${config.iconColor}`} />
        <span className={`text-sm font-medium ${config.textColor}`}>
          {message}
        </span>
        <button
          onClick={handleClose}
          className="ml-2 p-1 rounded-full hover:bg-white/10 transition-colors"
        >
          <X className="w-4 h-4 text-white/70 hover:text-white" />
        </button>
      </div>
    </div>
  );
}
